<template>

<div class="form-group form-group-sm">
	<label class="control-label col-sm-4">{{label}}</label>
	<div class="col-sm-4">
		<input type="number" min="1" class="form-control" v-model="amount">
	</div>
	<div class="col-sm-4">
		<select v-model="period" class="form-control">
		  <option v-for="option in accepted" :key="option.value" v-bind:value="option.value">
		    {{ option.text }}
		  </option>
		</select>
	</div>
</div>

</template>
<script type="text/javascript">
	export default {
		data(){
      if (!this.value){
        return
      }
			return {
				period: this.value.period,
				amount: this.value.amount,
				accepted: [
					{value: 'min', text: 'Minute'},
					{value: 'hour', text: 'Hour'},
					{value: 'week', text: 'Week'},
					{value: 'month', text: 'Month'},
					{value: 'day', text: 'Day'},
					{value: 'year', text: 'Year'},
				]
			}
		},
		props: ['value', 'label'],
		watch:{
			period(value){
				this.$emit('input', {amount: this.amount, period: value})
			},
			amount(value){
				this.$emit('input', {amount: value, period: this.period})
			}
		}
	}
</script>
